import React from "react";
import {
  FiShield,
  FiMonitor,
  FiLock,
  FiBriefcase,
  FiUsers,
  FiDatabase,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const solutionsData = [
  {
    title: "AI-SecOps",
    desc: "Centered on EventShield for modern security operations.",
    icon: <FiShield />,
  },
  {
    title: "Network Monitoring & Visibility",
    desc: "MCT Network Monitoring System, NCMS, and Maple Log.",
    icon: <FiMonitor />,
  },
  {
    title: "Zero Trust Access",
    desc: "MCTAuthenticator, MCTPAM, and MCT Access Watch.",
    icon: <FiLock />,
  },
  {
    title: "Enterprise Management",
    desc: "AI-powered MCTEMS, ITSM, and Asset Management.",
    icon: <FiBriefcase />,
  },
  {
    title: "Identity & Governance",
    desc: "Enterprise control and compliance solutions.",
    icon: <FiUsers />,
  },
  {
    title: "SaaS Business Workflows",
    desc: "MapleDoc, MapleLearn, and business workflow tools.",
    icon: <FiDatabase />,
  },
];

function Solutions() {
    const navigate = useNavigate();
  return (
    <div className="home-about pt-10 text-white min-h-screen">
      
      {/* Hero Section */}
      <section className="px-6 md:px-16 py-20">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          
          {/* Left Content */}
          <div>
            <p className="text-cyan-400 uppercase tracking-widest text-sm mb-4">
              Solutions
            </p>

            <h1 className="text-4xl md:text-6xl font-bold leading-tight">
              Solutions built around enterprise outcomes.
            </h1>

            <p className="text-gray-300 mt-6 text-lg">
              MapleCloud solutions combine product capabilities across
              security, monitoring, access, operations, and SaaS platforms.
            </p>
          </div>

          {/* Right Highlight Card */}
          <div className="bg-gradient-to-br from-[#08162e] to-[#102b5a] p-10 rounded-2xl border border-cyan-500/20 shadow-lg">
            <h2 className="text-2xl font-semibold mb-4">
              Outcome-led architecture
            </h2>
            <p className="text-gray-300">
              AI-SecOps, monitoring, zero trust, enterprise management,
              and business workflow digitization.
            </p>
          </div>
        </div>
      </section>

      {/* Solutions Grid */}
      <section className="px-6 md:px-16 pb-20">
        <div className="grid md:grid-cols-3 gap-6">
          {solutionsData.map((item, index) => (
            <div
              key={index}
              className="bg-[#071428] border border-cyan-500/10 rounded-2xl p-6 hover:border-cyan-400 hover:shadow-[0_0_20px_rgba(0,255,255,0.15)] transition duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-cyan-500/20 flex items-center justify-center text-cyan-400 text-xl mb-4">
                {item.icon}
              </div>

              <h3 className="text-xl font-semibold mb-3">
                {item.title}
              </h3>

              <p className="text-gray-400 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="px-6 md:px-16 pb-20">
        <div className="bg-gradient-to-r from-cyan-600 to-blue-700 rounded-3xl p-10 text-center">
          <h2 className="text-3xl font-bold mb-4">
            Need a custom enterprise solution?
          </h2>

          <p className="text-gray-100 mb-6 max-w-2xl mx-auto">
            We help organizations build secure, scalable infrastructure
            tailored to their business operations.
          </p>

          <button onClick={() => navigate('/contactpage')} className="bg-white text-black px-8 py-3 rounded-full font-semibold hover:scale-105 transition">
            Contact Us
          </button>
        </div>
      </section>
    </div>
  );
}

export default Solutions;